<template>
  <div
    class="rt-link"
    @click="click"
  >
    <el-link v-bind="$attrs">
      <slot />
    </el-link>
  </div>
</template>
<script>
export default {
  name: 'RtLink',
  methods: {
    click () {
      this.$emit('click');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtLink.vue?0826ee30